<div class="container">
  <div class="container-content ui-page-shell-modern">
    <app-comissao-list
      [commissionList]="commissionList"
      [count]="count"
    ></app-comissao-list>
  </div>
</div>
